import { render, staticRenderFns } from "./MemberShipOpeningMethod.vue?vue&type=template&id=2e856224&"
import script from "./MemberShipOpeningMethod.vue?vue&type=script&lang=js&"
export * from "./MemberShipOpeningMethod.vue?vue&type=script&lang=js&"
import style0 from "./MemberShipOpeningMethod.vue?vue&type=style&index=0&id=2e856224&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports